import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';

// Exports
type Props = { children: React.ReactNode };
export const ReactQueryProvider = ({ children }: Props) => {
  const queryClient = React.useMemo(() => {
    return new QueryClient();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
